import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import RolesPanelFull from '../containers/RolesPanelFull';
import RolesPanelNarrow from '../containers/RolesPanelNarrow';

const RolesPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: RolesPanelFull, narrow: RolesPanelNarrow }}
  />
);

export default RolesPanel;
